import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import es from '@/locales/es.json';
import en from '@/locales/en.json';

const defaultLocale = import.meta.env.VITE_DEFAULT_LOCALE ?? 'es';
const supported = (import.meta.env.VITE_SUPPORTED_LOCALES ?? 'es,en').split(',');

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: { translation: es },
      en: { translation: en },
    },
    fallbackLng: defaultLocale,
    supportedLngs: supported,
    interpolation: { escapeValue: false },
  });

export default i18n;
